export const MESSAGE_TYPES = {
  ACKNOWLEDGE: 'acknowledge',
  TEXT: 'text',
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio',
  FILE: 'file',
  MULTIPLE: 'multiple',
  FORM: 'form',
  ARTICLE: 'article',
};

const messageTypesRegex = [
  { type: MESSAGE_TYPES.IMAGE, regExp: /^image/i },
  { type: MESSAGE_TYPES.AUDIO, regExp: /^audio/i },
  { type: MESSAGE_TYPES.VIDEO, regExp: /^video/i },
];
const extensionTypes = [
  { type: MESSAGE_TYPES.IMAGE, regExp: /^(jpe?g|png|gif|webp|heic|heif|bmp)$/i },
  { type: MESSAGE_TYPES.AUDIO, regExp: /^(mp3|m4a|aac|wav|ogg|opus)$/i },
  { type: MESSAGE_TYPES.VIDEO, regExp: /^(mp4|mov|m4v|webm|avi|mkv)$/i },
];
const DEFAULT_ATTACHMENT_TYPE = { type: MESSAGE_TYPES.FILE };

const typeFromName = name => {
  if (typeof name !== 'string') return null;
  const ext = name.split(/[?#]/)[0].split('.').pop();
  return extensionTypes.find(({ regExp }) => regExp.test(ext))?.type || null;
};

const getTypeFromAttachments = ([attachment]) => {
  const mimeType =
    attachment.mimeType ||
    attachment.mime_type ||
    attachment.meta?.mimeType ||
    attachment.meta?.mime_type ||
    '';
  const matchFromRegex = messageTypesRegex.find(({ regExp }) => mimeType.match(regExp));
  if (matchFromRegex) return matchFromRegex.type;
  return typeFromName(attachment.name) || DEFAULT_ATTACHMENT_TYPE.type;
};

export const getMessageType = ({ attachments, isMandatory, form, article, title }) => {
  if (article) {
    return MESSAGE_TYPES.ARTICLE;
  }

  if (form) {
    return MESSAGE_TYPES.FORM;
  }
  if (isMandatory) {
    return MESSAGE_TYPES.ACKNOWLEDGE;
  }

  if (attachments?.length === 1) {
    return getTypeFromAttachments(attachments);
  }

  if (attachments?.length > 1) {
    return MESSAGE_TYPES.MULTIPLE;
  }

  return typeFromName(title) || MESSAGE_TYPES.TEXT;
};
